import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CalculateDurationService {
  constructor() {}

  public async calculateDuration(startDate: Date, finalDate: Date) {
    
        let dia = finalDate.getDate() - startDate.getDate();
        let mes = finalDate.getMonth() - startDate.getMonth();
        let year = finalDate.getFullYear() - startDate.getFullYear();

        if (mes < 0 || (mes === 0 && dia < 0)) {
          year--;
          mes += 12;
        }

        if (dia < 0) {
          mes--;
          dia += new Date(finalDate.getFullYear(), finalDate.getMonth(), 0).getDate();
        }

        let duration = `${year > 0 ? Math.abs(year) + ' años, ' : ''}${mes > 0 ? Math.abs(mes) + ' meses, ' : ''}${Math.abs(dia)} dias `;
        return duration        
  
  }

}
